module.exports = __webpack_public_path__ + "static/media/7.0d1ef0c5.svg";